import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import { useLocation, useNavigate } from 'react-router-dom';
import { Ionicons } from '@expo/vector-icons';

/**
 * Relleno inferior del contenido scrollable para que no quede tapado por la barra en overlay.
 * Debe alinear con la altura real outer + pill (márgenes incl.).
 */
export const COMENSAL_TAB_BAR_OVERLAY_INSET = 108;

type TabDef = {
  path: string;
  label: string;
  icon: keyof typeof Ionicons.glyphMap;
  iconActive: keyof typeof Ionicons.glyphMap;
};

const TABS: TabDef[] = [
  { path: '/', label: 'Home', icon: 'home-outline', iconActive: 'home' },
  { path: '/likes', label: 'Favoritos', icon: 'heart-outline', iconActive: 'heart' },
  { path: '/votar', label: 'Votar', icon: 'ticket-outline', iconActive: 'ticket' },
  { path: '/ruta', label: 'Ruta', icon: 'map-outline', iconActive: 'map' },
  { path: '/perfil', label: 'Perfil', icon: 'person-outline', iconActive: 'person' },
];

function isTabActive(pathname: string, tabPath: string): boolean {
  if (tabPath === '/') {
    return pathname === '/' || pathname.startsWith('/restaurantes-cercanos');
  }
  if (tabPath === '/votar') {
    return pathname === '/votar' || pathname === '/votar/';
  }
  return pathname === tabPath || pathname.startsWith(`${tabPath}/`);
}

export function ComensalBottomTabBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <View style={styles.outer} pointerEvents="box-none">
      <View style={styles.floatingBar}>
        {TABS.map((tab) => {
          const active = isTabActive(pathname, tab.path);
          const iconName = active ? tab.iconActive : tab.icon;
          return (
            <TouchableOpacity
              key={tab.path}
              style={styles.tab}
              onPress={() => navigate(tab.path)}
              activeOpacity={0.7}
              accessibilityRole="tab"
              accessibilityState={{ selected: active }}
              accessibilityLabel={tab.label}
            >
              <Ionicons name={iconName} size={24} color={active ? '#030213' : '#9ca3af'} />
              <Text style={[styles.label, active && styles.labelActive]}>{tab.label}</Text>
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  outer: {
    paddingHorizontal: 14,
    paddingTop: 6,
    paddingBottom: Platform.OS === 'ios' ? 18 : Platform.OS === 'android' ? 14 : 16,
    backgroundColor: 'transparent',
    width: '100%',
  },
  floatingBar: {
    flexDirection: 'row',
    alignItems: 'stretch',
    justifyContent: 'space-around',
    backgroundColor: '#ffffff',
    borderRadius: 18,
    borderWidth: 1,
    borderColor: '#e8eaed',
    paddingVertical: 10,
    paddingHorizontal: 6,
    ...Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 6 },
        shadowOpacity: 0.12,
        shadowRadius: 14,
      },
      android: {
        elevation: 10,
      },
      web: {
        boxShadow: '0 8px 24px rgba(15, 23, 42, 0.12)',
      },
    }),
  },
  tab: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 4,
  },
  label: {
    fontSize: 11,
    fontWeight: '500',
    color: '#9ca3af',
    marginTop: 2,
  },
  labelActive: {
    color: '#030213',
    fontWeight: '600',
  },
});
